import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { fetchUserAndSubscription } from '../redux/actions/user';
import Loader from '../components/Layout/Loader';
import { isCanonicalSuperAdmin } from '../utils/privateLaunchAccess';


const SubscriptionProtectedRoute = ({ children, requiredTiers }) => {
  const dispatch = useDispatch();
  const { isAuthenticated, user, loading, error } = useSelector((state) => state.user);
  const subscriptions = useSelector((state) => state.user.subscriptions);
  const [initialLoading, setInitialLoading] = useState(true); 
  const bypassesSubscription = isCanonicalSuperAdmin(user);

  useEffect(() => {
    if (!user || (!bypassesSubscription && !subscriptions)) {
      dispatch(fetchUserAndSubscription());
    } else {
      setInitialLoading(false); 
    }
  }, [dispatch, user, subscriptions, bypassesSubscription]);

 
  if (loading || initialLoading) {
    return <Loader />; 
  }

  if (error) {
    console.error('Error fetching user or subscriptions:', error);
    return <div>Error: {error}</div>;  
  }

  if (!bypassesSubscription && (!subscriptions || subscriptions.length === 0)) {
    console.log('No subscriptions data available');
    return <div>No Subscription Data</div>;
  }

  const hasRequiredTier = bypassesSubscription || subscriptions?.some(sub => requiredTiers.includes(sub.tier) && sub.status === 'active');
  
  if (!isAuthenticated || !hasRequiredTier) {
    console.log('Redirecting due to unmet conditions', { isAuthenticated, hasRequiredTier });
    return <Navigate to="/subscriptions" replace />;
  }

  return children; 
};

export default SubscriptionProtectedRoute;






